import type { RHProcurementOffer, RHProcurementPartOffer } from "../../../../models/prodModels"


export class RHProcurementPartOfferGrouping {

    static offersByPartOffer(
        offers: RHProcurementOffer[]
    ): Map<RHProcurementPartOffer, RHProcurementOffer> {
        const offersByPartOffer = new Map<RHProcurementPartOffer, RHProcurementOffer>()
        for (const offer of offers) {
            for (const partOffer of (offer.partOffers ?? []) as RHProcurementPartOffer[]) {
                offersByPartOffer.set(partOffer, offer)
            }
        }
        return offersByPartOffer
    }


    static partOffersByPartId(
        partOffers: RHProcurementPartOffer[]
    ): Map<string, RHProcurementPartOffer[]> {
        const partOffersByPartId = new Map<string, RHProcurementPartOffer[]>()

        for (const partOffer of partOffers) {
            const partId = partOffer.partId.toString()
            let offersForPart = partOffersByPartId.get(partId)
            if (!offersForPart) {
                offersForPart = []
                partOffersByPartId.set(partId, offersForPart)
            }
            offersForPart.push(partOffer)
        }

        return partOffersByPartId
    }

}
